<template>
  <b-card class="cardStyle h-100">
    <p class="m-0 title">
      <b-icon icon="grid3x3-gap-fill" scale="1.3"></b-icon>&nbsp; &nbsp; My Access Requests
    </p>
    <div v-if="loading" id="loading" class="text-center my-5 py-5">
      <b-spinner class="align-middle" label="Spinning" type="grow"></b-spinner>
    </div>
    <div v-if="!loading">
      <b-progress :max="max" class="mb-2 mt-4" height="2rem" show-progress>
        <div v-if="value === 0" class="progressBarInfo" style="font-size:14px">
          <strong> 0/ {{ max }}</strong>
        </div>
        <b-progress-bar :style="progressColor" :value="value">
          <div v-if="requests.length > 0" style="font-size:14px">
            <strong> {{ value }}/ {{ max }}</strong>
          </div>
          <div v-if="requests.length === 0">
            <strong class="text-dark" style="font-size:12px">
              No Access Request have been submitted yet.
            </strong>
          </div>
        </b-progress-bar>
      </b-progress>
      <div class="textStyle mb-1" style="color: #6F6F6F;">
        {{ message }}
      </div>
      <section v-if="requests.length > 0" class="mt-2 h-50">
        <div v-if="value === max" class="allRequestsTextStyle mt-3 pt-5">
          <p>All requests have been processed.</p>
        </div>
        <div v-else>
          <b-row v-for="(item, idx) in requestsToDisplay.slice(0, 2)" :key="idx" class="pt-1 pl-3">
            <b-col class="pl-0" cols="auto" style="font-size:14px;">
              <status :status="item.status" />
            </b-col>
            <b-col class="appTextStyle px-0">
              {{ item.application }}
            </b-col>
            <b-col class="pl-0" cols="auto">
              <b-button
                size="sm"
                variant="link"
                @click="redirectToRequest(item.salesforceParentID)"
              >
                <b-icon icon="arrow-right" scale="1" variant="dark"></b-icon>
              </b-button>
            </b-col>
            <hr class="solid my-2 ml-0 mr-4" style="width: 100%;" />
          </b-row>
        </div>
      </section>
      <section class="text-right" style="position: absolute;bottom: 10px;width: 90%;">
        <div class="explanationTextStyle">
          Please refer to the ‘My Access’ section on the Application Access page for details on all
          requests.
        </div>
        <b-button class="mt-0" pill variant="link" @click="redirectToApplicationAccess('my-access')"
          >Application Access
        </b-button>
      </section>
    </div>
  </b-card>
</template>

<script>
  import arrowUpCircle from '../../../../images/arrowUpCircle.png';
  import Status from '../../common/Status';

  export default {
    name: 'MyAccessRequests',
    components: {
      Status,
    },
    props: {
      studyId: {
        type: String,
      },
      siteId: {
        type: String,
      },
    },
    data() {
      return {
        loading: false,
        requests: [],
        requestsToDisplay: [],
        max: 1,
        value: 1,
        arrowUpCircle: arrowUpCircle,
      };
    },
    computed: {
      isEnrollmentOversight() {
        return this.$route.name.includes('oversight');
      },
      progressColor() {
        return this.requests.length > 0
          ? {
              background: 'linear-gradient(270deg, #0000C9 0%, rgba(64, 64, 215, 0.54) 100%)',
              opacity: '0.6',
            }
          : { background: '#e9ecef' };
      },
      message() {
        const text =
          'This represents the total completed access requests out of all access requests submitted for me.';
        return this.requests.length === 0 || this.value === this.max
          ? text
          : text + 'The two most recent pending requests are shown below.';
      },
    },
    created() {
      this.getMyAccessRequestTickets();
    },
    methods: {
      redirectToApplicationAccess(option) {
        this.$router.push({
          name: this.isEnrollmentOversight ? 'oversight-application-access' : 'application-access',
          query: {
            option: option,
          },
        });
      },
      async getMyAccessRequestTickets() {
        this.requests = [];
        try {
          this.loading = true;
          let response = await axios.get(`/api/get-access-requests`, {
            params: {
              study_id: this.studyId,
              site_number: this.siteId,
              email: window['Laravel']['user_email'],
              view: 'childView',
            },
          });
          if (response.status !== 204 && response.data['items'].length > 0) {
            this.requests = response.data['items'];
            this.requestsToDisplay = this.requests.filter(
              el => !['REJECTED', 'VERIFIED', 'CLOSED'].includes(el['status']),
            );
            this.max = this.requests.length;
            this.value = this.requests.filter(el => el['status'] === 'CLOSED').length;
          }
        } catch (error) {
          console.error(error);
        }
        this.loading = false;
      },
      redirectToRequest(ticketId) {
        this.$router.push({
          name: 'ticket-details',
          query: {
            option: 'view-study-access-requests',
          },
          params: { id: ticketId },
        });
      },
    },
  };
</script>

<style scoped>
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #0060aa;
  }

  .textStyle {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.5px;
  }

  .progressBarInfo {
    padding-top: 1rem;
    padding-right: 0.5rem;
    text-align: right;
    width: 100%;
  }

  .appTextStyle {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #2e2e2e;
  }
  .explanationTextStyle {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.5px;
    color: #6f6f6f;
  }
  .allRequestsTextStyle {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.5px;
    color: #383838;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
